import React, { Fragment } from "react"
import {Link} from "react-router-dom"

const HomeMenu = [
    {
        name: "Soluciones IT",
        routerPath: "/"
    },
    {
        name: "Desarrollo de Software",
        routerPath: "/software-development"
    },
    {
        name: "Ciberseguridad",
        routerPath: "/cyber-security"
    },
];

const Miscellaneous = [
    {
      name: "Nosotros",
      routerPath: "/about"
  },
    {
      name: "Servicios",
      routerPath: "/services"
  },
    {
      name: "Detalle de Servicios",
      routerPath: "/services-details"
  },
    {
      name: "Equipo",
      routerPath: "/team"
  },
    {
      name: "Detalle del Equipo",
      routerPath: "/team-details"
  },
    
    {
      name: "Precios",
      routerPath: "/price"
  },
    {
      name: "Preguntas Frecuentes",
      routerPath: "/faq"
  },
    {
      name: "Error-404",
      routerPath: "/error"
  },
    {
      name: "Iniciar Sesión",
      routerPath: "/login"
  },
    {
      name: "Registrarse",
      routerPath: "/signup"
  },
    {
      name: "Próximamente",
      routerPath: "/coming-soon"
  },
];


const ProjectMenu = [
  {
      name: "Proyectos Cuadrícula",
      routerPath: "/project-grid"
  },
  {
      name: "Proyectos Mosaico",
      routerPath: "/project-masonry"
  },
  {
      name: "Detalle del Proyecto",
      routerPath: "/project-details"
  },
];
const BlogMenu = [
  {
      name: "Blog Cuadrícula",
      routerPath: "/blog-grid"
  },
  {
      name: "Blog Mosaico",
      routerPath: "/blog-masonry"
  },
  {
      name: "Blog Clásico",
      routerPath: "/blog-classic"
  },
  {
      name: "Detalle de Blog V1",
      routerPath: "/blog-details-v1"
  },
  {
      name: "Detalle de Blog V2",
      routerPath: "/blog-details-v2"
  },
];


const ThemeMainMenu = () => {
  return (
    <Fragment>
        <ul className="navbar-nav main-navbar mb-2 mb-lg-0 ps-1">
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle drop-nav" href="#" id="navbarDropdownOne">
                Inicio
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdownOne">
                {HomeMenu.map((val, i)=>(
                  <li key={i}><Link className="dropdown-item" to={val.routerPath}>{val.name}</Link></li>
                ))}
              </ul>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link" href="#" id="navbarDropdownTwo">
                Páginas
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdownTwo">
                {Miscellaneous.map((val, i)=>(
                  <li key={i}><Link className="dropdown-item" to={val.routerPath}>{val.name}</Link></li>
                ))}
              </ul>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown">
                Proyectos
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                {ProjectMenu.map((val, i)=>(
                  <li key={i}><Link className="dropdown-item" to={val.routerPath}>{val.name}</Link></li>
                ))}
              </ul>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownThree">
                Blog
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdownThree">
                {BlogMenu.map((val, i)=>(
                  <li key={i}><Link className="dropdown-item" to={val.routerPath}>{val.name}</Link></li>
                ))}
              </ul>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">Contáctanos</Link>
            </li>
        </ul>
    </Fragment>
  )
}

export default ThemeMainMenu